import {Content, BtnClose, buttonStyle, AboutMoleculeWrapper} from "./styles";
import IconMolecula from "../../assets/icons/molecule_icon.svg";
import IconXClose from "../../assets/icons/xClose.svg";
import IconQuestion from "../../assets/icons/info-italic.svg";
import {useEffect, useRef, useState} from "react";
import {Button} from "@mui/material";

const MOLECULE_V1_URL = "https://drti-bkd.sandcloud.ru/molecules-ui/";
const MOLECULE_V2_URL = "http://89.208.223.153:8089/";

const SearchMoleculesTopBar: React.FC = () => {
  const [isShowAboutMolecule, setIsShowAboutMolecule] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        contentRef.current &&
        !contentRef.current.contains(event.target as Node)
      ) {
        setIsShowAboutMolecule(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Content>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "15px 15px 16px",
        }}
      >
        <div style={{display: "flex", gap: 8}}>
          <Button
            style={buttonStyle(false)}
            onClick={() => window.open(MOLECULE_V1_URL, "_blank")}
            size="small"
          >
            Молекула 1.0
          </Button>
          <Button
            color="inherit"
            style={buttonStyle(false)}
            onClick={() => window.open(MOLECULE_V2_URL, "_blank")}
            size="small"
          >
            Молекула 2.0
          </Button>
        </div>
        <img
          src={IconQuestion}
          width={20}
          height={20}
          alt=""
          style={{cursor: "pointer"}}
          onClick={() => setIsShowAboutMolecule(true)}
        />
      </div>

      <AboutMoleculeWrapper isShow={isShowAboutMolecule} ref={contentRef}>
        <div className="aboutMoleculeHeader">
          <div style={{display: "flex", alignItems: "center"}}>
            <img src={IconMolecula} alt="IconMolecula" />
            Что такое молекула 1.0?
          </div>
          <BtnClose style={{}} onClick={() => setIsShowAboutMolecule(false)}>
            <img
              src={IconXClose}
              alt=""
              style={{opacity: 0.7, marginRight: 0}}
            />
          </BtnClose>
        </div>
        <div style={{marginTop: 8}}>
          Молекула 1.0 показывает силу связи между продуктом и технологиями. Чем
          сильнее связь - тем важнее технология для создания продукта.
        </div>
        <hr />
        <div className="aboutMoleculeHeader">
          <div style={{display: "flex", alignItems: "center"}}>
            <img src={IconMolecula} alt="IconMolecula" />
            Что такое молекула 2.0?
          </div>
        </div>
        <div style={{marginTop: 8}}>
          Молекула 2.0 позволяет найти наиболее синергичные продукты компаний,
          которые помогут улучшить или создать целевой продукт.
        </div>
      </AboutMoleculeWrapper>
    </Content>
  );
};

export default SearchMoleculesTopBar;
